import { useEffect, useState } from 'react';
import { useAuthContext } from '../hooks/useAuthContext';
import { useCompanyContext } from '../hooks/useCompanyContext';
import axios from 'axios';

// components
import CompanyDetails from '../components/CompanyDetails';

const Home = () => {
  const { user } = useAuthContext();
  const { company, loading, dispatch: companyDispatch } = useCompanyContext();
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);

  console.log('🔁 Home render', { company, user });

  // Wis bedrijf volledig bij uitloggen
  useEffect(() => {
    if (!user) {
      companyDispatch({ type: 'CLEAR_COMPANY' });
      sessionStorage.removeItem('selectedCompany');
    }
  }, [user, companyDispatch]);

  // Haal users op zodra het bedrijf geladen is
  useEffect(() => {
    const fetchUsersForCompany = async (companyId) => {
      setUsersLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/user/by-company/${companyId}`,
          { headers: { Authorization: `Bearer ${user.token}` } }
        );

        const excludedEmails = ['andy@actorius.nl', 'info@am-bs.nl', 'info@actorius.nl'];

        const rawUsers = response.data.items || response.data || [];

        const filteredUsers = rawUsers.filter(
          (u) =>
            !u.roles?.includes('medewerker') &&
            !excludedEmails.includes((u.email || '').toLowerCase())
        );

        setUsers(filteredUsers);
      } catch (error) {
        console.error('Fout bij ophalen van gebruikers:', error);
      } finally {
        setUsersLoading(false);
      }
    };

    if (company?.Companyid && user?.token) {
      fetchUsersForCompany(company.Companyid);
    }
  }, [company, user]);

  const handleUserUpdated = (updated) => {
    setUsers((prev) =>
      prev.map((u) => (u._id === updated._id ? { ...u, ...updated } : u))
    );
  };

  if (loading) {
    return <p>⏳ Gegevens worden geladen...</p>;
  }

  if (!company) {
    return <p>❌ Geen bedrijfsinformatie beschikbaar.</p>;
  }

  return (
    <div className="home">
      {/* Toon bedrijfsinformatie */}
      <div className="company-details">
        {/* Geef de Set met e-mails door aan CompanyDetails */}
        <CompanyDetails webUsers={users} onUserUpdated={handleUserUpdated} />
      </div>



      {/* Gebruikers van dit bedrijf */}
      {/*
      <div style={{ marginTop: '40px' }}>
        <h3 className="pageheading">Gebruikers van dit bedrijf</h3>
        {usersLoading ? (
          <p>Gebruikers worden geladen...</p>
        ) : users.length === 0 ? (
          <p>Er zijn geen gebruikers gevonden.</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Naam</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Rollen</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u._id}>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{u.email}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                    {Array.isArray(u.roles)
                      ? u.roles.filter((role) => role !== 'gebruiker').length > 0
                        ? u.roles
                            .filter((role) => role !== 'gebruiker')
                            .sort((a, b) => a.localeCompare(b))
                            .join(', ')
                        : ''
                      : 'Geen rollen'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      */}
    </div>
  );
};

export default Home;
